import { div, mul } from './decimal';
import { isObject, isString } from './is';

export function setObjToUrlParams(baseUrl: string, obj: any): string {
  let parameters = '';
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}

export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
  let key: string;
  for (key in target) {
    src[key] = isObject(src[key]) ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
  }
  return src;
}

// 手机号格式化
export const formatPhone = (phone: string) => {
  return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
};

// 金额格式化
export const formatMoney = (amount: number) => {
  return `¥${amount.toFixed(2)}`;
};

// 单位分,转换为元
export function handleMoney(money?: number) {
  if (!money) {
    return 0;
  }
  if (money <= 0) {
    return money;
  }
  const reg = /^-*(?:\d+\.+\d+|\d{2,})$/;
  if (isString(money) && !reg.test(money)) {
    return money;
  } else {
    return div(money, 100);
  }
}
// 单位元,转换为分
export function handlePostMoney(money?: number): number {
  return Number(mul(money, 100));
}
